import { useEffect, useState } from 'react';

const MEASUREMENTS_INPUT_ID = 'property_research_property_attributes_measurements';
const DEFAULT_MEASUREMENT_AREA_LABEL = 'SF';

const readMeasurementAreaLabel = (): string => {
  const input = document.getElementById(MEASUREMENTS_INPUT_ID);
  if (!(input instanceof HTMLSelectElement) && !(input instanceof HTMLInputElement)) {
    return DEFAULT_MEASUREMENT_AREA_LABEL;
  }
  const raw = input.dataset.measurementLabels;
  if (!raw) return DEFAULT_MEASUREMENT_AREA_LABEL;
  try {
    const labels = JSON.parse(raw) as Record<string, { area?: string } | undefined>;
    return labels[input.value]?.area ?? DEFAULT_MEASUREMENT_AREA_LABEL;
  } catch {
    return DEFAULT_MEASUREMENT_AREA_LABEL;
  }
};

export const useMeasurementAreaLabel = (): string => {
  const [measurementAreaLabel, setMeasurementAreaLabel] = useState<string>(
    () => readMeasurementAreaLabel(),
  );

  useEffect(() => {
    const input = document.getElementById(MEASUREMENTS_INPUT_ID);
    if (!input) return undefined;
    const onChange = () => setMeasurementAreaLabel(readMeasurementAreaLabel());
    input.addEventListener('change', onChange);
    return () => input.removeEventListener('change', onChange);
  }, []);

  return measurementAreaLabel;
};
